import React, { Component, Fragment } from 'react';
import { Button, Card, Col, Form, Input, InputNumber, Row, Switch } from 'antd';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageListComponent, HeaderListComponent } from "../../../common/component/Index";
import TranslateButton from '../../../common/component/TranslateButton';
import * as Func from '../../../../../helpers/functions';
import { FEATURE_FLAGS } from "../../../../../constants/Define";
import DEFINE from "../../../../../constants/Define";
import { getCondimentDetail, updateCondiment, translateCondiment, deleteCondimentTranslate } from "../../../../../actions/fnbAction";
import { PATHS } from "../../../../../constants/Define";

const FormItem = Form.Item;
let permisionActions = {};

const emptyCondiment = {
    id: null,
    fnbProductId: '',
    code: '',
    isNoPrice: false,
    minSelection: 0,
    maxSelection: 0,
    isActive: false,
    createdDate: '',
    languageCode: 'vi-VN',
    translations: [],
};

class CondimentDetail extends Component {
    state = {
        condiment: emptyCondiment,
    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_PRODUCT_CONDIMENT);
        const { match } = this.props;
        const id = match?.params?.id;
        if (id) {
            this.props.actions.getCondimentDetail(id);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.condimentDetail !== this.props.condimentDetail && this.props.condimentDetail) {
            const condiment = this.normalizeCondimentDetail(this.props.condimentDetail);
            this.setState({ condiment });
        }

        if (!prevProps.condimentUpdateSuccess && this.props.condimentUpdateSuccess) {
            this.props.history.goBack();
        }
    }

    handleChangeName = (event) => {
        const name = event.target.value;
        this.setState((prevState) => ({
            condiment: {
                ...prevState.condiment,
                name,
            },
        }));
    };

    getDefaultLanguageCode = () => {
        const { condiment } = this.state;
        const defaultLang = (condiment.translations || []).find((item) => item.isDefault);
        return (defaultLang && defaultLang.languageCode) || condiment.languageCode || 'vi-VN';
    };

    normalizeCondimentDetail = (condimentDetail) => {
        const translations = condimentDetail.translations || [];
        const defaultLang = translations.find((item) => item.isDefault);
        const languageCode = (defaultLang && defaultLang.languageCode) || condimentDetail.languageCode || 'vi-VN';
        const name = this.getTranslationName(translations, languageCode) || '';
        return {
            ...condimentDetail,
            translations,
            languageCode,
            name,
        };
    };

    getTranslationName = (translations, languageCode) => {
        const translation = (translations || []).find((item) => item.languageCode === languageCode);
        return translation ? translation.name : '';
    };

    handleShowTranslate = (language) => {
        if (!language || !language.code) return;
        this.setState((prevState) => ({
            condiment: {
                ...prevState.condiment,
                languageCode: language.code,
                name: this.getTranslationName(prevState.condiment.translations, language.code),
            },
        }));
    };

    handleExitTranslate = () => {
        this.setState((prevState) => ({
            condiment: {
                ...prevState.condiment,
                languageCode: this.getDefaultLanguageCode(),
                name: this.getTranslationName(
                    prevState.condiment.translations,
                    this.getDefaultLanguageCode()
                ),
            },
        }));
    };

    handleRemoveTranslate = (language) => {
        if (!language || !language.code) return;
        const translation = (this.state.condiment.translations || []).find(
            (item) => item.languageCode === language.code
        );
        if (translation && translation.id) {
            this.props.actions.deleteCondimentTranslate({
                translateId: translation.id,
                condimentId: this.state.condiment.id,
                languageCode: language.code,
                languageName: this.props.t(`translate.languages.${language.id}`),
            });
            return;
        }
        this.setState((prevState) => {
            const translations = (prevState.condiment.translations || []).filter(
                (item) => item.languageCode !== language.code
            );
            const defaultLanguageCode = this.getDefaultLanguageCode();
            const nextLanguageCode =
                prevState.condiment.languageCode === language.code
                    ? defaultLanguageCode
                    : prevState.condiment.languageCode;
            return {
                condiment: {
                    ...prevState.condiment,
                    translations,
                    languageCode: nextLanguageCode,
                    name: this.getTranslationName(translations, nextLanguageCode),
                },
            };
        });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { condiment } = this.state;
        const { match } = this.props;
        const id = match?.params?.id || condiment.id;
        if (!id) return;
        const defaultLanguageCode = this.getDefaultLanguageCode();
        if (condiment.languageCode && condiment.languageCode !== 'vi-VN' && condiment.languageCode !== defaultLanguageCode) {
            const translation = (condiment.translations || []).find(
                (item) => item.languageCode === condiment.languageCode
            );
            this.props.actions.translateCondiment({
                id: translation?.id,
                fnbProductCondimentId: translation?.id ? undefined : id,
                condimentId: id,
                name: condiment.name || '',
                description: '',
                languageCode: condiment.languageCode,
                languageName: this.props.t(`translate.languages.${condiment.languageCode.split('-')[0]}`),
            });
            return;
        }
        const updatePayload = this.buildUpdatePayload(condiment);
        this.props.actions.updateCondiment({ id, updatePayload });
    };

    buildUpdatePayload = (condiment) => ({
        id: condiment.id,
        fnbProductId: condiment.fnbProductId,
        code: condiment.code,
        isNoPrice: Boolean(condiment.isNoPrice),
        minSelection: condiment.minSelection,
        maxSelection: condiment.maxSelection,
        isActive: Boolean(condiment.isActive),
        createdDate: condiment.createdDate,
        translations: (condiment.translations || []).map((item) => ({
            id: item.id,
            fnbProductCondimentId: item.fnbProductCondimentId || condiment.id,
            name:
                item.languageCode === this.getDefaultLanguageCode()
                    ? (condiment.name || item.name || '')
                    : (item.name || ''),
            description: item.description || '',
            languageCode: item.languageCode,
            isDefault: Boolean(item.isDefault),
        })),
    });

    render() {
        const { t, match, history } = this.props;
        const { condiment } = this.state;

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={Func.capitalizeFirstLetter(
                            (`${t('action.update')} ${t('navigation.condiment')}`).toLowerCase()
                        )}
                        extraBreadcrumbs={[
                            { title: t('navigation.condiment'), path: PATHS.FNB.CONDIMENT_MANAGER.LIST.path },
                            { title: t('action.update') + ' ' + t('navigation.condiment').toLowerCase() },
                        ]}
                        componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE && (
                            <TranslateButton
                                languages={condiment.translations}
                                current={condiment.languageCode}
                                onChange={this.handleShowTranslate}
                                onClear={this.handleExitTranslate}
                                onRemove={this.handleRemoveTranslate}
                            />
                        )}
                    />
                    <Card bordered={false}>
                        <Form layout="vertical" onSubmit={this.handleSubmit}>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Code">
                                        <Input value={condiment.code} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Name">
                                        <Input value={condiment.name} onChange={this.handleChangeName} />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Product id">
                                        <Input value={condiment.fnbProductId} disabled />
                                    </FormItem>
                                </Col>
                                <Col span={12}>
                                    <FormItem label="Created date">
                                        <Input value={condiment.createdDate} disabled />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={8}>
                                    <FormItem label="Min selection">
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            value={condiment.minSelection}
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem label="Max selection">
                                        <InputNumber
                                            min={0}
                                            style={{ width: "100%" }}
                                            value={condiment.maxSelection}
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                                <Col span={8}>
                                    <FormItem label="No price">
                                        <Switch
                                            checked={condiment.isNoPrice}
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row gutter={24}>
                                <Col span={12}>
                                    <FormItem label="Active">
                                        <Switch
                                            checked={condiment.isActive}
                                            disabled
                                        />
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span={24} style={{ textAlign: "right" }}>
                                    <Button style={{ marginRight: 8 }} onClick={() => history.goBack()}>
                                        {t('action.back')}
                                    </Button>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={this.props.condimentUpdateLoading || this.props.condimentTranslateLoading}
                                        disabled={!permisionActions || !permisionActions.allowUpdate}
                                    >
                                        {t('action.update')}
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    condimentDetail: state.fnbReducer.condimentDetail,
    condimentDetailLoading: state.fnbReducer.condimentDetailLoading,
    condimentUpdateLoading: state.fnbReducer.condimentUpdateLoading,
    condimentUpdateSuccess: state.fnbReducer.condimentUpdateSuccess,
    condimentTranslateLoading: state.fnbReducer.condimentTranslateLoading,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getCondimentDetail,
            updateCondiment,
            translateCondiment,
            deleteCondimentTranslate,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CondimentDetail));
